import { Box } from '@mui/material'
import { type ReactNode } from 'react'
import { type Color } from 'src/types'

type SubtitleProps = {
  children: ReactNode
  x?: number
  y?: number
  color?: Color
  backgroundColor?: Color
  borderColor?: Color
  boxShadowColor?: Color
}

const style = {
  fontSize: '24px',
  padding: '2px 8px 2px 8px',
  border: '1px solid #161124',
  boxShadow: '4px 4px #161124',
  width: 'fit-content'
}

const Subtitle = ({ children, x = 0, y = 0, color = '#161124', backgroundColor = '#e0959d', borderColor = '#161124', boxShadowColor = '#161124'}: SubtitleProps) => (
  <Box sx={{
    ...style,
    top: y,
    left: x,
    color,
    border: `1px solid ${borderColor}`,
    boxShadow: `4px 4px ${boxShadowColor}`,
    backgroundColor,
    '&:hover': {
      backgroundColor
    }
  }} className='cinematic_subtitle'>
    {children}
  </Box>
)

export default Subtitle
